import React from 'react';
import { Grid } from '@mui/material';

import QuerySex from './QuerySex';
import QueryDisease from './QueryDisease';
import QueryInterProc from './QueryInterProc';
import QueryMeasure from './QueryMeasure';

//import QueryGene from './QueryGene';
import QueryVariant from './QueryVariant';

import QueryImgDisease from './QueryImgDisease';
//import QueryImgMeasure from './QueryImgMeasure';
import QueryImgAnatomic from './QueryImgAnatomic';

import Tooltip from '@mui/material/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';

import Fieldset from './../../../components/Fieldset/Fieldset';

const InfoGender = () => {
  return (
    <div className="tooltip">
      Gender identity or biological sex of the patient as recorded in their
      health records.
    </div>
  );
};

const InfoInterProc = () => {
  return (
    <div className="tooltip">
      Patient’s past and current health conditions, treatments, surgeries, and
      other medical events that have occurred throughout their life.
    </div>
  );
};

function InfoMeasure() {
  return (
    <div className="tooltip">
      Quantitative data collected from serum, plasma or blood. Examples:
      <br />
      <ul>
        <li>pH of Blood &gt;= 7339</li>
        <li>Platelets [#/volume] in Blood = 165</li>
      </ul>
    </div>
  );
}

function InfoVariant() {
  return (
    <div className="tooltip">
      Genetic mutation of patient's viral genome with respect to reference
      genome (MN908947.3).
      <br />
      <br />
      For INDELS, you must enter the previous nucleotide. Examples:
      <br />
      <ul>
        <li>21618 C&gt;T</li>
        <li>44 C&gt;T</li>
        <li>27259 A&gt;C</li>
        <li>27382 GAT&gt;CTC</li>
      </ul>
      <br />
      For range limit to 100 bases. Examples:
      <br />
      <ul>
        <li>1-100</li>
        <li>200-300</li>
      </ul>
      <br />
      For aminoacid change, you must enter the aminoacid change. Examples:
      <br />
      <ul>
        <li>p.Ser135Arg (Gene: orf1ab)</li>
        <li>p.Phe924Phe (Gene: orf1ab)</li>
        <li>p.Pro13Leu (Gene: N)</li>
        <li>p.Arg203Lys (Gene: N)</li>
      </ul>
    </div>
  );
}

function InfoDiagnosis() {
  return (
    <div className="tooltip">Disease o condition through medical imaging.</div>
  );
}
function InfoImgAnatomic() {
  return (
    <div className="tooltip">
      Specific position or area within the body where imaging is taken.
    </div>
  );
}

function BeaconQueryMenu() {
  return (
    <>
      <Fieldset
        title=" Clinical "
        color="greylight"
        titleSize="0.9rem"
        borderWidth={0.1}
        borderRadius={2}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={0} sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={3}>
            Patient's gender
            <Tooltip
              title={<InfoGender></InfoGender>}
              placement="top-start"
              arrow
            >
              <sup>
                <FontAwesomeIcon icon={faCircleInfo} size="lg" />
              </sup>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <QuerySex />
          </Grid>
          <Grid item xs={0} sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={3}>
            Diseases
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <QueryDisease />
          </Grid>
          <Grid item xs={0} sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={3}>
            Medical history
            <Tooltip
              title={<InfoInterProc></InfoInterProc>}
              placement="top-start"
              arrow
            >
              <sup>
                <FontAwesomeIcon icon={faCircleInfo} size="lg" />
              </sup>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <QueryInterProc />
          </Grid>
          <Grid item xs={0} sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={3}>
            Measurements
            <Tooltip
              title={<InfoMeasure></InfoMeasure>}
              placement="top-start"
              arrow
            >
              <sup>
                <FontAwesomeIcon icon={faCircleInfo} size="lg" />
              </sup>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <QueryMeasure />
          </Grid>
        </Grid>
      </Fieldset>

      <Fieldset
        title=" Genomic "
        color="greylight"
        titleSize="0.9rem"
        borderWidth={0.1}
        borderRadius={2}
      >
        <Grid container spacing={2} alignItems="center">
          {/*<Grid item xs={4}>Gene</Grid>
                    <Grid item xs={8}>
                        <QueryGene />
                    </Grid>*/}
          <Grid item sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={3}>
            SARS-CoV-2 genetic mutation
            <Tooltip
              title={<InfoVariant></InfoVariant>}
              componentsProps={{
                tooltip: {
                  sx: {
                    minWidth: '420px',
                  },
                },
              }}
              placement="bottom"
              arrow
            >
              <sup>
                <FontAwesomeIcon icon={faCircleInfo} size="lg" />
              </sup>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <QueryVariant />
          </Grid>
        </Grid>
      </Fieldset>
      <Fieldset
        title=" Radiomics "
        color="greylight"
        titleSize="0.9rem"
        borderWidth={0.1}
        borderRadius={2}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Chip label="synthetic" size="small" /> Diagnosis
            <Tooltip
              title={<InfoDiagnosis></InfoDiagnosis>}
              placement="top-start"
              arrow
            >
              <sup>
                <FontAwesomeIcon icon={faCircleInfo} size="lg" />
              </sup>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <QueryImgDisease />
          </Grid>
          {/*<Grid item xs={4}>Measures imagen</Grid>
                <Grid item xs={8}>
                    <QueryImgMeasure />                    
                </Grid>*/}
          <Grid item sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Chip label="synthetic" size="small" /> Anatomical location
            <Tooltip
              title={<InfoImgAnatomic></InfoImgAnatomic>}
              placement="top-start"
              arrow
            >
              <sup>
                <FontAwesomeIcon icon={faCircleInfo} size="lg" />
              </sup>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <QueryImgAnatomic />
          </Grid>
        </Grid>
      </Fieldset>
    </>
  );
}

export default BeaconQueryMenu;
